import { v4 as uuidv4 } from "uuid";
import moment from "moment-jalaali";
import fa from "moment/locale/fa";
moment.locale("fa", fa);
moment.loadPersian({ dialect: "persian-modern" });

// convert Fa to En number
export const convertFaToEnNumber = (text) => {
  text = String(text);

  return text.replace(/[۰-۹]/g, (chr) => {
    let persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

    return persian.indexOf(chr);
  });
};

export const replaceAll = (text, search, replacement) => {
  if (!text) {
    return text;
  }

  return text.replace(new RegExp(search, "g"), replacement);
};

// format price
export const formatPrice = (price) => {
  if (!price) return 0;

  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// format date
export const dateFormat = (date, format = "jYYYY/jMM/jDD", locale = "fa") => {
  return moment(date).locale(locale).format(format);
};

export const toTime = (date) => {
  return moment.utc(date).format("HH:mm");
};


// generate static image url
export const generateStaticImageUrl = (imgUrl) => {
  return process.env.NODE_ENV !== "production" ? "http://localhost:17987" + imgUrl : imgUrl
}

// generate year list
export const generateYearList = (payload) => {
  const yearList = [];

  for (let i = payload.maxYear; i > payload.minYear; i--) {
    yearList.push({
      value: i,
      title: i,
      key: uuidv4(),
    });
  }
  return yearList;
};

export const isWithinTimeRange = (time, range) => time >= range.start && time < range.end;